/**
 * Created by lihanying on 2017/7/6.
 */

export const GETCLUBWALLETLIST = 'GETCLUBWALLETLIST'
export const GETCLUBWALLETTYPE = 'GETCLUBWALLETTYPE'
export const GETSELECTWALLET = 'GETSELECTWALLET'


// WEBPACK FOOTER //
// ./src/containers/ClubWallet/constants.js